import { createI18n } from 'vue-i18n';

import en from '@acs/components-library/src/translations/en/index.js';
import cs from '@acs/components-library/src/translations/cs/index.js';
import de from '@acs/components-library/src/translations/de/index.js';
import fr from '@acs/components-library/src/translations/fr/index.js';
import nl from '@acs/components-library/src/translations/nl/index.js';
import es from '@acs/components-library/src/translations/es/index.js';
import it from '@acs/components-library/src/translations/it/index.js';
import pl from '@acs/components-library/src/translations/pl/index.js';
import sv from '@acs/components-library/src/translations/sv/index.js';
import no from '@acs/components-library/src/translations/no/index.js';
import ro from '@acs/components-library/src/translations/ro/index.js';
import hr from '@acs/components-library/src/translations/hr/index.js';
import sr from '@acs/components-library/src/translations/sr/index.js';
import hu from '@acs/components-library/src/translations/hu/index.js';

import { captureSentryException } from '@acs/components-library/src/sentry.js';

const supported = [
  'en',
  'cs',
  'de',
  'fr',
  'nl',
  'es',
  'it',
  'pl',
  'sv',
  'no',
  'ro',
  'hr',
  'sr',
  'hu',
];

export function isSupportedLocale(value) {
  return supported.includes(value);
}

export function getLocalStorageLocale() {
  const locale = localStorage.getItem('locale');
  return isSupportedLocale(locale) ? locale : null;
}

export function setLocalStorageLocale(locale) {
  if (isSupportedLocale(locale)) {
    localStorage.setItem('locale', locale);
  }
}

export function getBrowserLocale() {
  const { 0: browserLang } = navigator.language.split('-');
  return isSupportedLocale(browserLang) ? browserLang : null;
}

export function getLocale(defaultLocale = 'en') {
  try {
    return getLocalStorageLocale() || getBrowserLocale() || defaultLocale;
  } catch (O_o) {
    captureSentryException(O_o); // highly unlikely if possible at all
    return defaultLocale;
  }
}

const i18n = createI18n({
  locale: getLocale(),
  fallbackLocale: 'en',
  legacy: true,
  globalInjection: true,
  allowComposition: true,
  messages: { en, cs, de, fr, nl, es, it, pl, sv, no, ro, hr, sr, hu },
});

export { i18n };
